exports.onRouteUpdate = () => {
    if (typeof window !== `undefined`) { 
        setTimeout(() => window.scrollTo(0, 0), 0)
    }
}
  
exports.shouldUpdateScroll = args => {
    return false;
};